import React, { useState } from 'react';
import { useAuth } from '../../stores/AuthContext';
import SearchInterface from '../search/SearchInterface';
//import Dashboard from './dashboard';

const TradingDashboard = () => {
  const [showSearch, setShowSearch] = useState(false);
  const { user: currentUser } = useAuth();
  
  return (
    <div className="pt-16 min-h-screen bg-background text-foreground">

          <SearchInterface userId={currentUser.id} />

    </div>
  );
};

export default TradingDashboard;